<article class="ds-notification" [ngClass]="hostClasses">
    <header class="ds-notification__header">
        <mat-icon class="ds-notification__header-icon" fontSet="material-symbols-rounded" aria-hidden="true">{{ themeIcon }}</mat-icon>

        <h4 class="ds-notification__header-title">{{ header }}</h4>
    </header>

    <div class="ds-notification__content" [innerHTML]="content"></div>

    <div class="ds-notification__actions">
        <ds-button size="sm" label="View" (buttonClick)="viewClick.emit()"></ds-button>

        <ng-container *ngIf="hasSnooze">
            <ds-button size="sm" theme="secondary" label="Snooze" icon="schedule" [matMenuTriggerFor]="snoozeMenu"></ds-button>

            <mat-menu #snoozeMenu="matMenu" class="snooze-options-menu">
                <button *ngFor="let option of snoozeOptions" mat-menu-item type="button" (click)="onSnoozeSelect(option.id)">
                    {{ option.name }}
                </button>
            </mat-menu>
        </ng-container>

        <ds-button size="sm" theme="tertiary-gray" label="Dismiss" (buttonClick)="dismissClick.emit()"></ds-button>
    </div>
</article>
